import Food from "./Food";

function App() {
  return (
    <>
      <div>
        <h1>Random Food Recipe</h1>
        <div className="underline"></div>
        <Food />
      </div>
    </>
  );
}

export default App;
